export const TEST_ID_MOBILE_SUMMARY_PRICE_TOTAL = 'mobile-summary-price-total';
